<template>
    <div class="animated fadeIn page-new">
        <b-row v-if="true">
            <b-form @submit.prevent="save" action="111" class="col-md-12" >
                <b-row>
                    <b-col sm="12" class="main-page">
                        <b-card footer-tag="footer">
                            <div slot="header">
                                <strong>Thêm thành viên</strong>
                            </div>
                            <b-row  v-bind:class="{'ptt-loading':loading}">
                                <b-col cols="12" xl="6" lg="8">
                                    <b-form-group
                                            label="Tên thành viên"
                                            label-for="input-name"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-name" type="text" placeholder="Nhập tên thành viên"  v-model="data.fullName"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Địa chỉ email"
                                            label-for="input-email"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-email" type="email" placeholder="Nhập email thành viên"  v-model="data.email"></b-form-input>
                                    </b-form-group>


                                    <b-row>
                                        <b-col cols="12" xl="8" lg="8">
                                            <b-form-group
                                                    label="Trạng thái"
                                                    label-for="input-status"
                                                    :label-cols="4"
                                                    :horizontal="true">
                                                <b-form-select id="input-status" v-model="data.status">
                                                    <option :value="1">Đang hoạt động</option>
                                                    <option :value="2">Ngừng hoạt động</option>
                                                    <option :value="3">Tạm Khóa</option>
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>


                                    </b-row>


                                  <hr>
                                  <h6>Thay đổi mật khẩu</h6>
                                  <b-form-group

                                    label="Mật khẩu"
                                    label-for="input-password"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <b-form-input id="input-password" type="text" placeholder="Nhập mật khẩu mới"  v-model="password1"></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                    label="Xác nhận mật khẩu"
                                    label-for="input-confirm-password"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <b-form-input id="input-confirm-password" type="text" placeholder="Xác nhận mật khẩu mới"  v-model="password2"></b-form-input>
                                  </b-form-group>
                                </b-col>
                            </b-row>
                            <div slot="footer" class="">
                                <b-button type="submit" variant="primary">Lưu lại</b-button>
                                <b-button type="button" class="ml-2" :to="{path:'/admin'}">Quay lại</b-button>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-form>
        </b-row>
        <b-row v-else>
          <p class="alert alert-warning">Bạn không có quyền truy cập mục này.</p>
        </b-row>
    </div>
</template>

<script>
import {isAuth, isSuperAdmin} from "@/utils/auth";
    import axios from "axios";

    export default {
        name: 'AdminAdd',
        components: {

        },
        data () {
            return {
                isSuperAdminAccount: false,
                data:{
                    fullName:null,
                    username:null,
                    email: null,
                    status: 1,
                },
                password1:null,
                password2: null,
                loading:false,
                group:[]
            }
        },
        mounted() {
          if (!isAuth() || !isSuperAdmin()) {
            this.$router.push('/login')
          }
        },
        created() {
          this.fetchData();
        },
        computed: {
        },
        watch: {
        },
        methods: {

          async save(){
            const {id} = this.$route.params || {}

            const user = this.$cookies.get('user');
            this.$gtag.event('click_update_admin', {
              event_category: 'click_events',
              event_label: 'Update admin button',
              user_type: 'admin',
              user_id: user?._id,
            });

            if (!id || id === "") {
              this.$toasted.error("Không tải được dữ liệu", {
                duration: 3000
              });
              return false;
            }
            //kiem tra bat buoc
            if(!this.data.fullName){
              this.$toasted.show("Vui lòng nhập tên",{
                type:"error",
                duration:5000
              });
              return false;
            }
            if(!this.data.email){
              this.$toasted.show("Vui lòng nhập địa chỉ email",{
                type:"error",
                duration:5000
              });
              return false;
            }

            if (this.password1
              && this.password1 !== '') {
              if (this.password1.length <= 5) {
                this.$toasted.show("Mật khẩu cần tối thiểu 6 ký tự", {
                  type: "error",
                  duration: 5000
                });
                return false;
              }
              else if (this.password1 !== this.password2) {
                this.$toasted.show("Nhập lại mật khẩu không chính xác", {
                  type: "error",
                  duration: 5000
                });
                return false;
              }
            }

            try {
              // Lấy token từ cookies
              const token = this.$cookies.get('token');

              let params = {
                  email: this.data.email,
                  username: this.data.username || "",
                  fullName: this.data.fullName || "",
                  status: parseInt(this.data.status)
              }

              if (this.password1) {
                params.password = this.password1
              }

              // Gửi yêu cầu API bằng Axios và đưa token vào header
              const {data} = await axios.put(this.$configs.api + '/api/v4/cp/admin/' + id,
                params, {
                  headers: {
                    Authorization: `Bearer ${token}`
                  },

                });

              this.$gtag.event('update_admin', {
                event_category: 'admin_events',
                event_label: 'Update admin',
                user_type: 'admin',
                user_id: user?._id,
                req: JSON.stringify(params) || null,
                res: JSON.stringify(data) || null,
              });

              if (data && data._id) {
                this.$toasted.success("Đã lưu thành công",{
                  duration:5000
                });
                this.$router.push({ path: `/admin/${data._id}` })
              }
            } catch (err) {
              // Kiểm tra xem có lỗi phản hồi từ máy chủ không
              if (err.response && (err.response.status === 500 || err.response.status !== 200)) {

                console.log(err.response)
                this.$toasted.error( err.response.data.message || "Đã xảy ra lỗi không mong muốn từ máy chủ", {
                  duration: 5000
                });
              } else {
                // Xử lý các lỗi khác
                this.$toasted.error(err.message, {
                  duration: 5000
                });
              }
            }
          },
          async fetchData() {
            // let id = this.$route.params.id;
            const {id} = this.$route.params || {}
            if (!id || id === "") {
              this.$toasted.error("Không tải được dữ liệu", {
                duration: 3000
              });
              this.$router.push({path: "/admin"});
              return false;
            }
            this.loading = true;

            try {
              // Lấy token từ cookies
              const token = this.$cookies.get('token');

              // Gửi yêu cầu API bằng Axios và đưa token vào header
              const {data} = await axios.get(this.$configs.api + '/api/v4/cp/admin/' + id,
                {
                  headers: {
                    Authorization: `Bearer ${token}`
                  },
                });

              if (data && data._id) {
                this.data = data
                console.log(`fetch`,this.data)
              }

            } catch (err) {

              if (err.response && err.response.status === 500) {
                this.$toasted.error(err.response.data.message || "Đã xảy ra lỗi không mong muốn từ máy chủ", {
                  duration: 5000
                });
              } else {
                this.$toasted.error(err.message, {
                  duration: 5000
                });
              }
            } finally {
              this.loading = false
            }

            // this.$http.get(this.$configs.api + `/api/user/${id}`)
            //     .then( respons => {
            //         this.data = respons.data;
            //         try {
            //             if (this.data && this.data.group.toString() === '5d28131cae52713abc2c3772') {
            //               this.isSuperAdminAccount = true;
            //             }
            //             delete this.data._id;
            //             delete this.data.createdAt;
            //             delete this.data.updatedAt;
            //         }catch (e) {
            //             console.log(e);
            //         }
            //         this.loading = false;
            //     })
            //     .catch( err => {
            //         this.$toasted.show(err.message,{
            //             type: "error",
            //             duration: 5000
            //         });
            //         this.loading = false;
            //         this.$router.push({path:"/user-group"});
            //     });
          },
        }
    }
</script>

